import { render, staticRenderFns } from "./UserMsg.vue?vue&type=template&id=42957782&scoped=true&"
import script from "./UserMsg.vue?vue&type=script&lang=js&"
export * from "./UserMsg.vue?vue&type=script&lang=js&"
import style0 from "./UserMsg.vue?vue&type=style&index=0&id=42957782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42957782",
  null
  
)

export default component.exports